import { Serializers, SerializerValue } from "@megaron/serializers";

export const notificationFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  startDate: Serializers.datetime,
  endDate: Serializers.datetime,
  app: Serializers.string,
}).partial();

export type NotificationFilters = SerializerValue<typeof notificationFiltersSerializer>;
